<template>
  <modal @close="$emit('close')">
    <h4 slot="title">
      {{ deactivateUser? $t('deactivateUser'):$t('deleteMember') }}
    </h4>
    <section
      slot="body"
      class="modal-confirm-action"
    >
      <p class="confirmation">
        {{ deactivateUser?$t('deleteYourselfFromTeamAreYouSure'):$t('deleteMemberFromTeam', { x: memberIndex.fullName }) }}
      </p>
      <p class="warning">
        {{ $t('thisCannotBeUndone') }}
      </p>
      <div class="buttons">
        <button
          class="clavo-button clavo-button-danger-primary"
          @click="deactivateUser ? $emit('deactivate-user', memberIndex):$emit('deleteMember', memberIndex)"
        >
          {{ $t('delete') }}
        </button>
        <button
          class="clavo-button secondary"
          @click="$emit('close')"
        >
          {{ $t('cancel') }}
        </button>
      </div>
    </section>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'DeleteMemberPopup',
  components: {
    Modal,
  },
  props: {
    memberIndex: Object,
    deactivateUser: { type: Boolean, default: false }
  },
  created() {},
}
</script>

<style lang="scss"></style>
